
import Vue from 'vue'
import { Component, Model, Prop, Watch } from 'vue-property-decorator'

@Component<InputMultiLine>({})
export default class InputMultiLine extends Vue {
    @Prop({ type: Boolean, required: false, default: false })
    public readonly disabled!: boolean

    @Prop({ type: Boolean, required: false, default: false })
    public readonly error!: boolean

    @Prop({ type: Boolean, required: false, default: false })
    public readonly grow!: boolean

    @Prop({ type: String, required: false, default: '' })
    public readonly label!: string

    @Prop({ type: Number, required: false })
    public readonly limit?: number

    @Prop({ type: Boolean, required: false, default: false })
    public readonly applyImportantBorderStyleHack!: boolean

    @Prop({ type: String, required: false, default: '' })
    public readonly placeHolder!: string

    @Model('input', { type: String, default: '' })
    public value!: string

    public get currentLimit(): string {
        const limit = this.limit
        const length = this.value.length

        if (!length || limit === undefined) {
            return ''
        }
        if (length < limit) {
            return `${length}/${limit}`
        }
        return 'You have reached the character limit'
    }
}
